import React, { ReactNode } from "react";
import TitleSquare from "./TitleSquare";
import { style } from "../style";
function withBasePath(path: string): string
{
    return process.env.PUBLIC_URL + path;
}

export default function WindowPanel(
    props:
        {
            title: string,
            imagePath?: string,
            contentList?: string[],
            contentGrid?: React.JSX.Element,
            contentText?: string,
            addedClassGroup?: string
        }
)
{

    let content: ReactNode = null;

    // IMAGE PATH
    if (props.imagePath !== undefined)
    {
        content = (
            // <div className={style.contentWrapper}>
            <img className={style.image} src={withBasePath(props.imagePath)} alt={props.title} />);
    }

    // LIST
    else if (props.contentList !== undefined)
    {
        let listItems: ReactNode[] = [];

        for (let i = 0; i < props.contentList.length; i++)
        {
            listItems.push(<li key={i}>{props.contentList[i]}</li>);
        }

        content = (
            <div className={style.contentWrapper}>
                <ul className={style.ul}>{listItems}</ul>
            </div>);
    }
    // GRID
    else if (props.contentGrid !== undefined)
    {
        content = (
            <div className={style.contentWrapper}>
                {props.contentGrid}
            </div>);
    }
    // TEXT
    else if (props.contentText !== undefined)
    {
        content = (
            <div className={style.contentWrapper + " " + style.prose + " " + "p-2"}>
                <p>{props.contentText}</p>
            </div>);
    }

    return (
        <div className={style.panel + " " + style.panelBorder + " " + props.addedClassGroup}>
            <h3 className={style.h3}> <TitleSquare />{props.title}</h3>
            {content}
        </div>
    );
}